import { DataRoomAccessStatus } from 'shared';

import { StringKey } from '../../lang/index';
import { DataRoomAccessAction } from './space.types';

export type AccessActionCopy = {
  body: StringKey;
  confirmLabel: StringKey;
  // Revoking is the one action that takes something away, so its confirm button is drawn in red.
  isDestructive: boolean;
  successMessage: StringKey;
  title: StringKey;
};

const REVOKE_ACCESS: AccessActionCopy = {
  body: 'CONFIRM_REVOKE_ACCESS',
  // Its own key, not the `REVOKE_ACCESS` the stakeholder and team screens share: the copy here is
  // sentence case, and theirs is not ours to recase.
  confirmLabel: 'REVOKE_ACCESS_CONFIRM',
  isDestructive: true,
  successMessage: 'ACCESS_REVOKED_SUCCESSFULLY',
  title: 'REVOKE_ACCESS_TITLE',
};

/**
 * Revoking somebody who never got in takes no access away from them: what it retires is every
 * link already sent to that address, which is the thing the Admin is deciding about. The same
 * request, a different question — so the modal and the toast both say invitation, not access.
 */
const REVOKE_INVITE: AccessActionCopy = {
  body: 'CONFIRM_REVOKE_INVITE',
  confirmLabel: 'REVOKE_INVITE',
  isDestructive: true,
  successMessage: 'INVITATION_REVOKED_SUCCESSFULLY',
  title: 'REVOKE_INVITE_TITLE',
};

const COPY_BY_ACTION: Record<DataRoomAccessAction, AccessActionCopy> = {
  [DataRoomAccessAction.REACTIVATE]: {
    body: 'CONFIRM_GRANT_ACCESS',
    confirmLabel: 'GRANT_ACCESS',
    isDestructive: false,
    successMessage: 'ACCESS_GRANTED_SUCCESSFULLY',
    title: 'GRANT_ACCESS_TITLE',
  },
  [DataRoomAccessAction.RESEND]: {
    body: 'CONFIRM_RESEND_INVITE',
    confirmLabel: 'RESEND_INVITE',
    isDestructive: false,
    successMessage: 'INVITATION_RESENT_SUCCESSFULLY',
    title: 'RESEND_INVITE_TITLE',
  },
  [DataRoomAccessAction.REVOKE]: REVOKE_ACCESS,
};

export const accessActionCopy = ({
  action,
  status,
}: {
  action: DataRoomAccessAction;
  status: DataRoomAccessStatus;
}): AccessActionCopy =>
  action === DataRoomAccessAction.REVOKE && status === DataRoomAccessStatus.PENDING
    ? REVOKE_INVITE
    : COPY_BY_ACTION[action];
